export interface IntegrateBibliographyRequest {
  id: number
  prefix: string
  targetBibliographyRealId: number
  targetPrefix: string
}

export function IntegrateBibliographyRequestToJSON(
  value: IntegrateBibliographyRequest
): any {
  return {
    id: value.id ? value.id : undefined,
    prefix: value.prefix !== '' ? value.prefix : undefined,
    target_bibliography_real_id: value.targetBibliographyRealId
      ? value.targetBibliographyRealId
      : undefined,
    target_prefix: value.targetPrefix !== '' ? value.targetPrefix : undefined
  }
}
